import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';
import { useQuery } from '@apollo/client';

// Components & Styles
import s from './EditBlogDetails.css';
import Loader from '../../../components/Loader/Loader';
import NotFound from '../../notFound/NotFound';
import EditBlogDetailsManagement from '../../../components/siteadmin/EditBlogDetails/EditBlogDetails';

// Query
import editBlogDetails from './editBlogDetails.graphql';

function EditBlogDetails({ title, blogId }) {
  const { data, loading } = useQuery(editBlogDetails, {
    variables: { id: blogId },
    fetchPolicy: 'network-only',
    ssr: false,
  });

  if (loading) {
    return <div><Loader type="text" /></div>;
  }

  if (!data || !data.editBlogDetails) {
    return <NotFound />
  }

  return (
    <EditBlogDetailsManagement
      title={title}
      initialValues={data.editBlogDetails}
    />
  );
}

EditBlogDetails.propTypes = {
  title: PropTypes.string.isRequired,
  blogId: PropTypes.number.isRequired,
};

export default withStyles(s)(EditBlogDetails);
